import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/category/${movie.category}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${
        size === 'large' ? 'aspect-[2/3]' : 'aspect-[2/3]'
      }`}>
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 八戒电影网高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />

        {movie.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            热播
          </span>
        )}
        {movie.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
            新上
          </span>
        )}

        <div className="absolute top-2 right-2">
          {!movie.isNew && movie.isHot && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
              热门
            </span>
          )}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1.5 mb-1">
            <span className="text-accent-400 text-xs font-semibold">{movie.rating}</span>
            <div className="flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`text-[10px] ${
                    star <= Math.round(movie.rating / 2)
                      ? 'ri-star-fill text-accent-400'
                      : 'ri-star-line text-foreground-400'
                  }`}
                ></i>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-2 text-background-200 text-xs">
            <span>{movie.year}</span>
            <span className="w-1 h-1 rounded-full bg-background-400"></span>
            <span>{movie.duration}</span>
            <span className="w-1 h-1 rounded-full bg-background-400"></span>
            <span>{movie.region}</span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors line-clamp-1">
        {movie.title}
      </h3>
      <p className="text-foreground-500 text-xs mt-0.5 line-clamp-1">{movie.titleEn}</p>
    </Link>
  );
}